import { BINARY_FONT, BINARY_NUMBER_OF_LEVELS, BINARY_SYSTEM, COLOR_DARK, COLOR_MEDIUMDARK, FONT, MAYA_FONT, MAYA_NUMBER_OF_LEVELS, MAYA_SYSTEM, ROMAN_FONT, ROMAN_NUMBER_OF_LEVELS, ROMAN_SYSTEM } from "../defaults";
import info_icon from "../images/info.png";
import mascot_computer from "../images/mascot_computer.png";
import mascot_maya from "../images/mascot_maya.png";
import mascot_roman from "../images/mascot_roman.png";
import { ChooseSystemPopupBinary, ChooseSystemPopupMaya, ChooseSystemPopupMessage, ChooseSystemPopupRoman, lang } from "../strings";


const ChooseSystemPopup = ({
  handleClose,
  show,
  setWhichSystem,
  displayInfoModal,
  progress,
  setLevel
}) => {
  const popupmain = {
    background: COLOR_MEDIUMDARK,
    position: "absolute",
    left: "50%",
    top: "5%",
    transform: "translateX(-50%)",
    width: "90%",
    height: "90%",
    border: "1dvh solid rgba(255, 255, 255, 0.15)",
    borderRadius: "0.5em",
    padding: "0dvh 5dvh",
    boxSizing: "border-box"
  };

  const popup = {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    backgroundColor: COLOR_DARK,
    display: "flex",
    justifycontent: "center",
    alignitems: "center",
    display: show ? "flex" : "none",
    zIndex: "6",
    fontFamily: FONT,
    textShadow: "0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5)",
  };

  const buttonSection = {
    width: "40dvh",
    border: "1dvh solid rgba(255, 255, 255, 0.15)",
    borderRadius: "0.5em",
    position: "absolute",
    left: "50%",
    bottom : "15%",
    transform: "translateX(-50%)",
    backgroundColor: COLOR_MEDIUMDARK
  };

  const handleChooseRoman = () => {
    // Highest unlocked level is usually progress(whichSystem). Unless all levels are unlocked, then progress is highest_unlocked_level + 1, i.e. progress points behind the highest level.
    const highestUnlockedLevel = progress(ROMAN_SYSTEM) < ROMAN_NUMBER_OF_LEVELS ? progress(ROMAN_SYSTEM) : ROMAN_NUMBER_OF_LEVELS-1; 
    setWhichSystem(ROMAN_SYSTEM);
    setLevel(highestUnlockedLevel); // After changing system, jump to highest unlocked level.
    handleClose(); // Sets show to false, making popup invisible.
  }

  const handleChooseBinary = () => {
    // Highest unlocked level is usually progress(whichSystem). Unless all levels are unlocked, then progress is highest_unlocked_level + 1, i.e. progress points behind the highest level.
    const highestUnlockedLevel = progress(BINARY_SYSTEM) < BINARY_NUMBER_OF_LEVELS ? progress(BINARY_SYSTEM) : BINARY_NUMBER_OF_LEVELS-1; 
    setWhichSystem(BINARY_SYSTEM);
    setLevel(highestUnlockedLevel); // After changing system, jump to highest unlocked level.
    handleClose(); // Sets show to false, making popup invisible.
  }

  const handleChooseMaya = () => {
    // Highest unlocked level is usually progress(whichSystem). Unless all levels are unlocked, then progress is highest_unlocked_level + 1, i.e. progress points behind the highest level.
    const highestUnlockedLevel = progress(MAYA_SYSTEM) < MAYA_NUMBER_OF_LEVELS ? progress(MAYA_SYSTEM) : MAYA_NUMBER_OF_LEVELS-1; 
    setWhichSystem(MAYA_SYSTEM);
    setLevel(highestUnlockedLevel); // After changing system, jump to highest unlocked level.
    handleClose(); // Sets show to false, making popup invisible.
  }

  return (
    <div style={popup}>
      <button 
        onClick={displayInfoModal}
        className="info-button">
        <img src={info_icon} style={{width: "2.5dvh", height: "2.5dvh"}}/>
      </button>
      <section style={popupmain}>
        
        <div style={{marginTop: "10dvh", fontSize: "5dvh"}}>{ChooseSystemPopupMessage}</div>
        <div style={buttonSection}>
          <img src={mascot_roman} style={{position: "absolute", top: "2.3dvh", left: "-8dvh", height: "9.4dvh", width: "4.7dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
          <button
            onClick={handleChooseRoman}
            className="choose-system-popup-button"
            style={{fontFamily: ROMAN_FONT, fontSize: lang === 2 ? "3dvh" : "4dvh"}} // Scale down for french language.
          >
            {ChooseSystemPopupRoman}
          </button>
          <div></div>
          <img src={mascot_computer} style={{position: "absolute", top: "17.55dvh", left: "-9.5dvh", height: "6.9dvh", width: "6.9dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
          <button
            onClick={handleChooseBinary}
            className="choose-system-popup-button"
            style={{fontFamily: BINARY_FONT}}
          >
            {ChooseSystemPopupBinary}
          </button>
          <div></div>
          <img src={mascot_maya} style={{position: "absolute", top: "30.3dvh", left: "-8dvh", height: "9.4dvh", width: "4.7dvh", filter: "drop-shadow(0.3svh 0.3svh 0.6svh rgba(0, 0, 0, 0.5))"}}/>
          <button
            onClick={handleChooseMaya}
            className="choose-system-popup-button"
            style={{fontFamily: MAYA_FONT}}
          >
            {ChooseSystemPopupMaya}
          </button>
        </div>
        
      </section>
    </div>
  );
};

export default ChooseSystemPopup;
